/**
 * Application Configuration
 * 
 * Centralized configuration file for app-wide settings.
 * Update these values to customize links, contact information, and other settings.
 */

export const appConfig = {
  // Calendly scheduling link
  calendlyUrl: '/schedule-demo.html',

  // Contact information
  contact: {
    email: 'hello@topeshows.com',
    phone: '+1 (917) 695-5684',
    address: 'TOP Eshows, 30 N Gould St Ste N, Sheridan, WY 82801',
  },

  // Social media links 
  social: {
    // twitter: 'https://twitter.com/topeshows',
    // linkedin: 'https://linkedin.com/company/topeshows',
  },

};

export default appConfig;

